import { type ReactNode } from 'react';
import { useMouseParallax } from '@/hooks/use-mouse-parallax';

const TEXT_STYLE = {
  fontSize: 'clamp(280px, 42vw, 520px)',
  WebkitTextStroke: '1px rgba(255, 68, 68, 0.07)',
  color: 'transparent',
  letterSpacing: '0.05em',
};

export function Background3333(): ReactNode {
  const { x, y } = useMouseParallax(0.008);
  return (
    <div
      className="pointer-events-none absolute inset-0 overflow-hidden"
      aria-hidden
    >
      <div
        className="absolute inset-0 flex items-center justify-center"
        style={{ transform: `translate(${x}px, ${y}px)` }}
      >
        <span
          className="select-none font-display font-bold leading-none"
          style={TEXT_STYLE}
        >
          3333
        </span>
      </div>
    </div>
  );
}
